import Google from "../shared/googleapi.js"

var kTASK_STORAGE_KEY = "tasksInfo";
var GoogleTasks = {
  init: function() {
  },
  data: undefined,
  getData: function() {
    if (!this.data) this.data = JSON.parse(localStorage.getItem(kTASK_STORAGE_KEY));
    if (this.dataIsValid(this.data)) {
      return this.data;
    }

    return undefined;
  },
  setData: function (data) {
    this.data = data;
    localStorage.setItem(kTASK_STORAGE_KEY, JSON.stringify(data));
    document.redraw(true);
  },
  clearData: function() {
    localStorage.removeItem(kTASK_STORAGE_KEY)
  },
  downloadInterval: 15 * 60 * 60 * 1000,
  dataIsValid: function(data) {
    if (!data) return false;
    if (!data.timestamp) return false;
    return +new Date() - data.timestamp < this.downloadInterval;
  },
  clearTaskData: function() {
    this.data = undefined;
    localStorage.removeItem(kTASK_STORAGE_KEY);
  },
  tasksRequest: function(taskListId) {
    return gapi.client.request({
      path: 'tasks/v1/lists/' + taskListId + '/tasks',
      params: {
        'showCompleted': false
      }
    });
  },
  updateTask: function(taskId, taskListId, patch) {
    if (!gapi || !gapi.client) {
      alert("Google api is not available");
      location.clearAndReload();
    }
    gapi.client.tasks.tasks.patch(
      {'task': taskId, 'tasklist': taskListId, 'resource':patch}
    ).then(function(response) {
      GoogleTasks.scheduleTaskDownload();
    });
  },
  fetchIfNeeded: function() {
    if (!this.getData()) {
      this.fetch()
    }
  },
  fetching: false,
  fetch: function() {
    if (!gapi || !gapi.client || !gapi.client.tasks) return;
    if (GoogleTasks.fetching) return;
    document.setStatus("Downloading task lists")
    GoogleTasks.fetching = true;
    gapi.client.tasks.tasklists.list({
        // 'maxResults': 10
    })
    .then(function(response) {
      GoogleTasks.fetching = false;
      var taskLists = response.result.items;
      document.setStatus(`Downloading ${taskLists.length} task lists`)

      if (taskLists && taskLists.length > 0) {
        var batch = window.gapi.client.newBatch();
        for (var i = 0; i < taskLists.length; i++) {
          var taskList = taskLists[i];
          batch.add(GoogleTasks.tasksRequest(taskList.id), { id: taskList.id });
        }
        batch.then( function(batchResponse) {

      document.setStatus(`Downloaded ${taskLists.length} task lists`)
          var result = batchResponse.result;
          for (var i = 0; i < taskLists.length; i++) {
            var taskList = taskLists[i];
            taskList.items = result[taskList.id].result.items
          }
          
          var info = {
            timestamp: +new Date(),
            taskLists: taskLists
          }
          GoogleTasks.setData(info)       
        });
      } else {
      }
    });
  },
  downloadTimeout: null,
  scheduleTaskDownload: function() {
    clearTimeout(this.downloadTimeout);
    this.downloadTimeout = setTimeout(function(){
      this.downloadTimeout = null;
      GoogleTasks.fetch()
    }, 5000);
}


}

  
module.exports = GoogleTasks




